


























































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import ListingAudienceSelector from '@ui/Campaign/ListingAudienceSelector'
import ListingAudiencePersonaSelector from '@ui/Campaign/ListingAudiencePersonaSelector'

settings =
  name: "AudienceSelectorStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]
    components: {
      ListingAudienceSelector,
      ListingAudiencePersonaSelector,
    }

    data: ->
      # setAudience: false
      setAudiencePersona: false

    mounted: ->
      # @initializeSetAudience()
      @initializeSetAudiencePersona()

    computed:
      # actionsForListingAudienceSelector: ->
      #   {
      #     select: @selectListingAudience,
      #     unselect: @unselectListingAudience,
      #     selectAll: @selectAllListingAudiences,
      #     unselectAll: @unselectAllListingAudiences,
      #   }
      actionsForListingAudiencePersonaSelector: ->
        {
          select: @selectListingAudiencePersona,
          unselect: @unselectListingAudiencePersona,
          selectAll: @selectAllListingAudiencePersonas,
          unselectAll: @unselectAllListingAudiencePersonas,
          setScoreType: @setAudiencePersonasScoreType,
        }

    methods:
      # initializeSetAudience: ->
      #   { types } = @wizard.campaignData.target.audience
      #   @setAudience = true if types.length

      # selectListingAudience: (option) ->
      #   @wizard.campaignData.target.audience.types.push option.key
      # unselectListingAudience: (option) ->
      #   @wizard.campaignData.target.audience.types = @wizard.campaignData.target.audience.types.filter((audience) -> audience isnt option.key)
      # selectAllListingAudiences: (options) ->
      #   @wizard.campaignData.target.audience.types = options.map((option) -> option.key)
      # unselectAllListingAudiences: ->
      #   @wizard.campaignData.target.audience.types = []

      # hiToggleSetAudience: (value) ->
      #   @setAudience = value
      #   @unselectAllListingAudiences() if not value

      initializeSetAudiencePersona: ->
        { persona_segments } = @wizard.campaignData.target.audience
        @setAudiencePersona = true if persona_segments.length

      selectListingAudiencePersona: (option) ->
        @wizard.campaignData.target.audience.persona_segments.push option.key
      unselectListingAudiencePersona: (option) ->
        @wizard.campaignData.target.audience.persona_segments = @wizard.campaignData.target.audience.persona_segments.filter((personaSegment) -> personaSegment isnt option.key)
      selectAllListingAudiencePersonas: (options) ->
        @wizard.campaignData.target.audience.persona_segments = options.map((option) -> option.key)
      unselectAllListingAudiencePersonas: ->
        @wizard.campaignData.target.audience.persona_segments = []
      setAudiencePersonasScoreType: (value) ->
        @wizard.campaignData.target.audience.score_type = value
        @syncTarget()

      hiToggleSetAudiencePersona: (value) ->
        @setAudiencePersona = value
        @unselectAllListingAudiencePersonas() if not value

export default VueOptions.vue settings
